module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "hello"
  }, [_vm._h('h1', [_vm._s(_vm.msg)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38198426!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 16
// module chunks = 1